import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WidgetCard from "./WidgetCard";
import { COLORS } from "@ts/constants";

interface ISalesVsPriceCompetitiveAnalysisWidgetData {
    price: number;
    sales: number;
    volume: number;
    productName: string;
    skuTitle: string;
}

interface ISalesVsPriceCompetitiveAnalysisWidget {
    widgetData: ISalesVsPriceCompetitiveAnalysisWidgetData[];
    title: string;
    currencySymbol: string;
}

const SalesVsPriceCompetitiveAnalysisWidget: React.FC<
    ISalesVsPriceCompetitiveAnalysisWidget
> = ({ widgetData, title, currencySymbol }) => {
    
    const seriesData = widgetData.map((item, index) => ({
        x: item.price,
        y: item.sales,
        z: item.volume,
        name: item.productName,
        color: COLORS[index],
        skuTitle: item.skuTitle,
    }));

    const options = {
        chart: {
            type: "bubble",
        },
        title: {
            text: title,
        },
        subtitle: {
            text: "",
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            title: {
                text: `Price (${currencySymbol})`,
            },
            gridLineWidth: 1,
        },
        credits: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: "Sales",
            },
            gridLineWidth: 1,
        },
        tooltip: {
            useHTML: true,
            formatter: function (this: any) {
                return `
                    <b>Product Name:</b> ${this.point.skuTitle}<br>
                    <b>Price:</b> ${currencySymbol} ${this.point.x.toFixed(2)}<br>
                    <b>Sales:</b> ${this.point.y}<br>
                    <b>Units sold:</b> ${this.point.z}
                `;
            },
        },
        series: [
            {
                data: seriesData,
                dataLabels: {
                    enabled: true,
                    format: "{point.name}",
                    style: {
                        color: "black",
                    },
                },
            },
        ],
    };

    return (
        <WidgetCard
            overwriteDefaultClass={true}
            className="bg-transparent border-0 rounded-0 shadow-none"
        >
            <HighchartsReact highcharts={Highcharts} options={options} />
        </WidgetCard>
    );
};

export default SalesVsPriceCompetitiveAnalysisWidget;